import * as types from './constants';

// Get Lookbook Order
export const getLookbookOrderRequest = data => (
  { type: types.GET_LOOKBOOK_ORDER_REQUEST, payload: data }
);

export const getLookbookOrderDone = data => (
  { type: types.GET_LOOKBOOK_ORDER_DONE, payload: data }
);

export const getLookbookOrderFailed = errors => (
  { type: types.GET_LOOKBOOK_ORDER_FAILED, payload: errors }
);

export const getLookbookOrderReset = () => (
  { type: types.GET_LOOKBOOK_ORDER_RESET }
);